var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "advertisementPage"
  }, [_c('div', {
    staticClass: "content-holder"
  }, [_c('div', {
    staticClass: "container section-holder"
  }, [(!_vm.isLoggedIn) ? _c('div', {
    staticClass: "noticemsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('login.alerts.logout_success')))])]) : _vm._e()]), _vm._v(" "), _c('trendingCourses')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36cf5b1d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/advertisement/advertisementPage.vue
// module id = D0Ff
// module chunks = 1